import { render, staticRenderFns } from "./pk10.vue?vue&type=template&id=f04c1618&"
import script from "./pk10.vue?vue&type=script&lang=js&"
export * from "./pk10.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports